<template>
  <div class="flex m-2 flex-col h-full w-1/2">
    <div class="flex mb-4">
      <div class="flex-1">
        <h5>{{ $t('INTEGRATION_SETTINGS.MOBILE_APP.SUBTITLE') }}</h5>
      </div>
    </div>
    <div class="flex w-full md:w-1/2">
      <a href="https://apps.apple.com/app/id1598783695" target="_blank" rel="noopener noreferrer" class="flex-1">
        <img src="https://d33wubrfki0l68.cloudfront.net/814d5384ef54c6996e1ebb76c103acd448eaf018/a45fc/images/home/mobile-apps/app-store.png" alt="Apple app store" >
      </a>
      <a href="https://play.google.com/store/apps/details?id=co.il.digital99.chat" target="_blank" rel="noopener noreferrer" class="flex-1">
        <img src="https://d33wubrfki0l68.cloudfront.net/fb32fa6315ef7b4721fce6f662fdf10f62a3a2a5/05af7/images/home/mobile-apps/play-store.png" alt="Google play store" >
      </a>
    </div>
    <p class="text-sm mt-12">{{ $t('INTEGRATION_SETTINGS.MOBILE_APP.QR_CAPTION') }}</p>
    <qr-code-generator />
  </div>
</template>

<script>
import QrCodeGenerator from "./QrCodeGenerator.vue";

export default {
  name: "MobileApp",
  components: { QrCodeGenerator }
};
</script>

<style scoped>

</style>
